<template>
  <div>
    <div class="breadcrumb" style="padding-left:10px;margin-top:15px;">
      <v-breadcrumb>
        <!-- <v-breadcrumb-item>
          <v-icon type="home"></v-icon>
          <a @click="() => $router.push('/employee/dashboard')">Dashboard </a>
        </v-breadcrumb-item> -->
        <v-breadcrumb-item>
          <span>Students</span>
        </v-breadcrumb-item>
      </v-breadcrumb>
    </div>

    <div style="margin-top:20px;">
      <div class="table" v-if="canEdStudents">
        <div class="trow">
          <div class="thead id" @click="() => sortStudents('seq_id')">Student ID</div>
          <div class="thead full-name" @click="() => sortStudents('full_name')">Full Name</div>
          <div class="thead email" @click="() => sortStudents('email')">email</div>
          <div class="thead phone-number" @click="() => sortStudents('phone_number')">Phone Number</div>
          <div class="thead actions">Actions</div>
        </div>
        <div class="trow">
          <div class="tdata id">
            <input type="text" placeholder="Search Student ID" v-model="searchID" @keyup="(ev) => searchStudent('searchID', ev.target.value)" />
          </div>
          <div class="tdata full-name">
            <input type="text" placeholder="Search Student Name" v-model="searchFullName" @keyup="(ev) => searchStudent('searchFullName', ev.target.value)" />
          </div>
          <div class="tdata email">
            <input type="text" placeholder="Search Email" v-model="searchEmail" @keyup="(ev) => searchStudent('searchEmail', ev.target.value)" />
          </div>
          <div class="tdata phone-number">
            <input type="text" placeholder="Search Phone Number" v-model="searchPhoneNumber" @keyup="(ev) => searchStudent('searchPhoneNumber', ev.target.value)" />
          </div>
          <div class="tdata actions"></div>
        </div>
        <div class="trow" v-for="student in filteredStudents" :key="student.id">
          <div class="tdata id">{{student.seq_id}}</div>
          <div class="tdata full-name">{{student.full_name}}</div>
          <div class="tdata email">{{student.email}}</div>
          <div class="tdata phone-number">{{student.phone_number}}</div>
          <div class="tdata actions">
            <router-link :to="`/${$route.path.split('/')[1]}/edit-student-profile/${student.id}`">
              <v-button type="primary" size="small" @click="() => EditStudent(student)">Edit</v-button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EmployeeViewStudents',
  data () {
    return {
      searchID: '',
      searchFullName: '',
      searchEmail: '',
      searchPhoneNumber: '',
      fetchedStudents: null,
      filteredStudents: null,
      sorted: {}
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'canEdStudents'
    ])
  },
  watch: {
    canEdStudents: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getCanEdStudents')
        } else if (val) {
          this.fetchedStudents = val.map(x => {
            if (x.personal_details) {
              x.full_name = `${x.personal_details.first_name} ${x.personal_details.last_name}`
              x.email = x.personal_details.personal_email
              x.phone_number = x.personal_details.phone_number
            } else {
              x.full_name = x.email = ''
              x.phone_number = null
            }
            return x
          })
          this.filteredStudents = [...this.fetchedStudents]
        }
      },
      immediate: true
    }
  },
  methods: {
    userAction (data) {
      if (data.content === 'Logout') {
        fb.logout()
        this.$router.push('/auth')
      }
    },
    searchStudent (key, val) {
      this[key] = val

      if (!this.searchID && !this.searchFullName && !this.searchEmail && !this.searchPhoneNumber) {
        this.filteredStudents = [...this.fetchedStudents]
      } else {
        this.filteredStudents = this.fetchedStudents.filter(x => {
          if (this.searchID && x.seq_id &&
            (x.seq_id + '').indexOf(this.searchID.toLowerCase()) !== -1) {
            return true
          }
          if (this.searchFullName && x.full_name &&
            x.full_name.toLowerCase().indexOf(this.searchFullName.toLowerCase()) !== -1) {
            return true
          }
          if (this.searchEmail && x.email &&
            x.email.toLowerCase().indexOf(this.searchEmail.toLowerCase()) !== -1) {
             return true
          }
          if (this.searchPhoneNumber && x.phone_number &&
            x.phone_number.toLowerCase().indexOf(this.searchPhoneNumber.toLowerCase()) !== -1) {
            return true
          }
          return false
        })
      }
    },
    sortStudents (col) {
      if (this.sorted[col] === undefined) {
        this.sorted[col] = true
      } else {
        this.sorted[col] = !this.sorted[col]
      }

      let students = [...this.filteredStudents]
      if (this.sorted[col]) {        
        this.filteredStudents = students.sort((x, y) => (x[col] || '') > (y[col] || '') ? 1 : (y[col] || '') > (x[col] || '') ? -1 : 0)
      } else {
        this.filteredStudents = students.sort((x, y) => (x[col] || '') > (y[col] || '') ? -1 : (y[col] || '') > (x[col] || '') ? 1 : 0)
      }
    }
  }
}
</script>

<style scoped>
.table {
  width: 98%;
  margin: auto;
  overflow: auto;
}
.table .trow {
  display: flex;
  flex-direction: row;
}
.table .thead {
  font-size: 13px;
  padding: 7px 6px;
  background-color: #404040;
  color: ivory;
  border: 1px solid rgba(255, 255, 240, .2);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.table .thead:first-child {
  border-top-left-radius: 2px;
}
.table .thead:last-child {
  border-top-right-radius: 2px;
}
.table .tdata {
  font-size: 12px;
  padding: 5px 6px;
  border: 1px solid rgba(131, 127, 127, 0.137);
  display: flex;
  align-items: center;
}
.table .tdata input {
  width: 100%;
  margin: auto;
  padding: 4px 7px;
  height: 28px;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(0,0,0,.65);
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  -webkit-transition: all .3s;
  transition: all .3s;
}
.trow .id {
  width: 20%;
}
.trow .full-name {
  width: 24%;
}
.trow .email {
  width: 24%;
}
.trow .phone-number {
  width: 20%;
}
.trow .actions {
  min-width: 12%;
  width: 12%;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Employee/EmployeeViewStudents.vue